import { ElementType } from 'react';

type Props = {
    location: any;
    renderHeadingsAs?: ElementType;
    headingsClassName?: string;
    layout?: 'horizontal' | 'vertical';
    justifyCenter?: boolean;
};

export default function LocationSchedule({
    location,
    renderHeadingsAs = 'div',
    headingsClassName = 'font-display text-lg md:text-xl',
    layout = 'vertical',
    justifyCenter = true,
}: Props) {
    const Heading = renderHeadingsAs;
    const scheduleLines = location.schedule?.split(/\r\n|\r|\n/g) || [];

    if (!scheduleLines.length) return null;

    const data: { heading: string; lines: [string, string][] }[] = scheduleLines.reduce(
        (current, item) => {
            const groups = item
                .split(/:\s+/g)
                .map((i) => i.trim())
                .filter((i) => !!i);

            if (groups.length === 0) {
                return current;
            }

            if (groups.length === 1) {
                return [...current, { heading: groups[0], lines: [] }];
            }

            current[current.length - 1].lines.push([groups[0], groups[1]]);
            return current;
        },
        [{ heading: 'Program de funcționare', lines: [] }],
    );

    return (
        <div
            className={`${justifyCenter ? 'mx-auto' : ''} flex flex-col gap-4${
                layout === 'horizontal' ? ` md:flex-row md:gap-8 lg:gap-16${data.length === 1 ? ' md:w-1/2' : ''}` : ''
            }`}>
            {data.map((group, index, array) => (
                <div key={`group-${index}`} className="flex-1">
                    <Heading className={headingsClassName}>{group.heading}</Heading>
                    {group.lines.map((line, index) => (
                        <div className="flex" key={`line-${index}`}>
                            <div className="w-1/2 text-left">{line[0]}</div>
                            <div className="w-1/2 text-right">{line[1]}</div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
